import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import backendService from '../services/backendService';

function useRandomIcebreaker() {
  const [cursor, setCursor] = useState(0);
  const cacheKey = cursor > 0 ? ['daily-icebreaker', cursor] : ['daily-icebreaker'];

  const { data, isFetching } = useQuery(
    cacheKey,
    () => backendService.instance.discover.anonymised.randomIcebreaker(cursor),
    { staleTime: 1000 * 60 * 5 },
  );

  const fetchNew = () => {
    setCursor(c => c + 1);
  };

  return {
    fetchNew,
    data,
    isLoading: isFetching,
  };
}

export default useRandomIcebreaker;
